export class BatchIngestionPipelineMetricsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "metricsByPipelineId",
            "baseName": "metricsByPipelineId",
            "type": "{ [key: string]: IngestionPipelineMetrics; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchIngestionPipelineMetricsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
